<template>
	<!--热血盲盒管理- 随机盒子配置 -->
	<div class="debris_config-box">
		<!-- header头部 -->
		<header>
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item>
					<el-button type="primary" @click="openDialog(1)">添加配置</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleExport">导出</el-button>
				</el-form-item>
				<el-form-item>
					<el-switch v-model="switch_status" :active-value="1" :inactive-value="0" active-text="开启免费房间"
						inactive-text="关闭免费房间" @change="changeEvent"></el-switch>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="openFreeTimeDialog">添加免费盒子时间段</el-button>
				</el-form-item>
			</el-form>
		</header>
		<!-- body内容 -->
		<div class="body-box">
			<el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
				<el-table-column prop="id" label="配置ID" align="center">
				</el-table-column>
				<el-table-column prop="nums" label="房间模式" align="center">
					<template slot-scope="{ row }">
						<span v-if="row.nums === 2">双人</span>
						<span v-if="row.nums === 3">三人</span>
					</template>
				</el-table-column>
				<el-table-column prop="rand_nums" label="出现个数" align="center">
					<template slot-scope="{ row }">
						<span>{{ row.rand_nums }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="box_list" label="房间箱子id" align="center">
					<template slot-scope="{ row }">
						<span>{{ row.box_list }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="房间费用" align="center">
					<template slot-scope="{ row }">
						<span>{{ row.price }}</span>
					</template>
				</el-table-column>
				<el-table-column label="充值时间" align="center">
					<template slot-scope="{ row }">
						<p>{{ row.limit_start_time }}</p>
						<span>-</span>
						<p>{{ row.limit_end_time }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="limit_recharge_money" label="充值金额" align="center">
					<template slot-scope="{ row }">
						<span>{{ row.limit_recharge_money }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="配置状态" align="center">
					<template slot-scope="{ row }">
						<el-tag type="success" v-if="row.status === 1">正常</el-tag>
						<el-tag type="danger" v-if="row.status === 2">关闭</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="last_hour_status" label="此小时关闭中" align="center">
					<template slot-scope="{ row }">
						<el-tag type="success" v-if="row.last_hour_status == 1">是</el-tag>
						<el-tag type="info" v-if="row.last_hour_status == 0">否</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="action" label="操作" align="center" fixed="right" width="300px">
					<template slot-scope="{ row }">
						<el-form :inline="true" class="demo-form-inline" style="margin-bottom: 10px">
							<el-button type="primary" size="small" @click="openDialog(2, row)">编辑</el-button>
							<el-upload accept=".xls,.xlsx" :show-file-list="false" :on-success="onSuccess" :on-error="onError"
								style="display: inline-flex; margin-left: 20px" :action="action + '/' + row.id" :headers="headers">
								<el-button size="mini" type="primary" icon="el-icon-upload2">
									上传表
								</el-button>
							</el-upload>
						</el-form>
						<el-form :inline="true" class="demo-form-inline">
							<el-button type="primary" size="small" @click="downloadExcel(row)">下载表<i
									class="el-icon-download el-icon--right"></i></el-button>
							<el-button type="danger" size="small" @click="handleDelete(row)">删除表<i
									class="el-icon-delete el-icon--right"></i></el-button>
						</el-form>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
				:current-page="dataMeta.current_page" @current-change="handlePageChange"
				v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
		</div>

		<!-- 添加弹窗 -->
		<AddRandomBoxDialog v-model="dialogInfos" :visible="addVisible" :type="dialogType" @close="addVisible = false"
			@refresh="getData()"></AddRandomBoxDialog>

		<!-- 免费盒子的时间端弹窗 -->
		<AddFreeBoxTime v-model="dialogInfos" :visible="freeTimeVisible" :type="dialogType" @close="freeTimeVisible = false"
			@refresh="getData()">
		</AddFreeBoxTime>
	</div>
</template>
<script>
	import {
		mapActions,
		mapMutations,
		mapState
	} from 'vuex'
	import http, {
		server,
		api,
		delApiData,
		getApiData,
		postApiData,
		patchApiData
	} from '@/http'
	import saveFile from '@/utils/saveFile'
	import AddRandomBoxDialog from '@/components/battle/AddRandomBoxDialog.vue'
	import AddFreeBoxTime from '@/components/battle/AddFreeBoxTime.vue'
	import {
		getCookie
	} from '@/utils/cookie'

	export default {
		components: {
			AddRandomBoxDialog,
			AddFreeBoxTime
		},
		data() {
			return {
				addVisible: false, //添加队伍弹窗显示标志
				freeTimeVisible: false, //免费盒子的时间端标志
				loading: false, //加载动画
				query: {
					page: 1
				},
				switch_status: 0, //PK开关,0是关闭，1是打开
				groupList: undefined, //分组列表
				dataList: undefined, //数据列表
				dialogType: 1, //1是添加 2是修改 默认是1
				dialogInfos: undefined, //传给弹窗的数据
				dataMeta: undefined, //底部跳转页面条
			}
		},
		computed: {
			headers() {
				return {
					Authorization: 'Bearer ' + getCookie('access_token')
				}
			},
			action() {
				return `${api}battle_user_import`
			}
		},
		created() {
			this.getData() //获取数据列表
			this.getSwitchStatus() //获取开关状态
		},
		methods: {
			getData() {
				this.loading = true
				let params = this.query
				getApiData('battle_room', params)
					.then(res => {
						this.dataList = res.data
						//设置底部导航条数据
						this.dataMeta = res
					})
					.finally(() => {
						this.loading = false
					})
			},
			handlePageChange(page) {
				//页面底部跳转页面
				this.query.page = page
				this.getData();
			},
			openFreeTimeDialog() {
				//打开添加免费盒子的时间段弹窗
				this.freeTimeVisible = true
			},
			openDialog(num, val) {
				//打开添加队伍弹窗
				this.addVisible = true
				if (num === 1) {
					this.dialogType = 1
					this.dialogInfos = undefined
				}
				if (num === 2) {
					this.dialogType = 2
					this.dialogInfos = JSON.parse(JSON.stringify(val))
				}
			},
			getSwitchStatus() {
				//获取控制免费盒子状态按钮
				getApiData('battle_rand_enable')
					.then(res => {
						if (res) {
							res.data ? this.switch_status = 1 : this.switch_status = 0
						}
					})
			},
			changeEvent() {
				//控制免费盒子状态按钮
				let params = {
					"black": this.switch_status ? 1 : 0
				}
				patchApiData('battle_rand_enable', params)
					.then(res => {
						this.$message.success('操作成功！')
					}).catch(err => {
						//关闭/打开红包按钮失败，还原标志
						this.switch_status = this.switch_status ? 0 : 1
					})

			},
			handleExport() {
				this.buttonLoading = true

				http
					.get(
						api + 'battle_room_export', {
							responseType: 'arraybuffer'
						}
					)
					.then(res => {
						saveFile(res, {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							name: '随机盒子记录.xlsx'
						})
					}).finally(() => {
						this.buttonLoading = false
					})
			},
			onSuccess(res) {
				//上传文件成功
				this.$message.success("上传成功！");
			},
			onError(err) {
				this.$message.error("上传失败！");
			},
			downloadExcel(rowInfo) {
				//下载excel模版
				http
					.get(
						api + 'battle_user_export/' + rowInfo.id, {
							responseType: 'arraybuffer'
						}
					)
					.then(res => {
						saveFile(res, {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							name: '免费房间用户表.xlsx'
						})
					}).finally(() => {
						this.buttonLoading = false
					})
			},
			handleDelete(rowInfo) {
				//删除表
				//删除主播
				this.$confirm('确定要删除吗？', {
					type: 'warning'
				}).then(res => {
					delApiData(`battle_user_del/${rowInfo.id}`).then(res => {
						this.$message.success('删除成功！')
						this.getData()
					})
				})
			}
		}

	}

</script>
<style lang="less" scoped>
</style>
